import { styled } from '@mui/material';
import { Box } from '@o2/ui';
import { FC, ReactNode } from 'react';

interface SidesheetFooterProps {
  children: ReactNode;
}

const StyledFooterGradient = styled(Box, {
  name: 'O2Sidesheet',
  slot: 'footerGradient',
})(() => ({
  '&': {
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%)',
    width: '100%',
    height: '32px',
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translateY(-100%)',
  },
}));

const Footer: FC<SidesheetFooterProps> = ({ children, ...props }) => {
  return (
    <Box display="flex" flexDirection="column" position="relative" pt={1} pb={4} px={2.5} {...props}>
      <StyledFooterGradient />
      {children}
    </Box>
  );
};

export default Footer;
